import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { WorkplaceProvider } from '../../providers/workplace/workplace';

@IonicPage()
@Component({
  selector: 'page-workplaces',
  templateUrl: 'workplaces.html',
})
export class WorkplacesPage {

  workplaces;
  
  constructor(
    public alertCtrl: AlertController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public workplaceProvider: WorkplaceProvider,
  ) {
    this.workplaces = workplaceProvider.getWorkplaces();
  }

  addWorkplace() {
    this.navCtrl.push('MapPage', { mode: 'addWorkplace' });
  }

  map(workplace) {
    this.navCtrl.push('MapPage', { mode: 'workplace', workplace: workplace });
  }

  removeWorkplace(workplace) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar centro de trabajo',
      subTitle: workplace.name,
      message: '¿Seguro que quiere eliminarlo?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {}
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.workplaceProvider.remove(workplace.key).then(() => {
              this.showMessage('Centro de trabajo eliminado.')
            })
          }
        }
      ]
    });
    
    alert.present();
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/workplaces/workplaces.ts